export let SelectionState = /*#__PURE__*/function (SelectionState) {
  SelectionState[SelectionState["Empty"] = 0] = "Empty";
  SelectionState[SelectionState["Partial"] = 1] = "Partial";
  SelectionState[SelectionState["Full"] = 2] = "Full";
  return SelectionState;
}({});